module.exports = __webpack_public_path__ + "img/img_01.505da457.jpg";